import React, { useMemo } from 'react';
import VuiBox from "components/ui/VuiBox";
import BarChart from "components/charts/BarChart";
import ChartInfoTooltip from "components/Tooltip/ChartInfoTooltip";
import StandardLoadingIndicator from "components/StandardLoadingIndicator";
import StandardMessageDisplay from "components/StandardMessageDisplay";
import { getTopMentionedProductsChartOptions } from "../data/productChartOptions";
import { chartTooltips } from "components/Tooltip/Definitions/data"; // Assuming tooltip definition exists
import GlassCard from "components/GlassCard";

function TopMentionedProducts({ topProductsData, loading, error, competitorName }) {

  const chartData = useMemo(() => {
    if (!topProductsData || topProductsData.length === 0) return [];
    return [{
      name: "Total Mentions", // Single series for this bar chart
      data: topProductsData.map(product => product.totalMentions),
    }];
  }, [topProductsData]);

  const categories = useMemo(() => {
    if (!topProductsData || topProductsData.length === 0) return [];
    return topProductsData.map(product => product.productName);
  }, [topProductsData]);

  const chartOptions = useMemo(() => getTopMentionedProductsChartOptions(categories), [categories]);

  const renderContent = () => {
    if (loading) {
      return <StandardLoadingIndicator containerHeight="350px" />;
    }
    if (error) {
      return (
        <StandardMessageDisplay
          type="error"
          containerHeight="350px"
        />
      );
    }
    if (!topProductsData || topProductsData.length === 0) {
      return (
        <StandardMessageDisplay
          type="noData"
          title="No Top Products Data"
          message={`No top mentioned products found for ${competitorName} in the selected timeframe.`}
          containerHeight="350px"
        />
      );
    }
    return (
      <VuiBox sx={{ height: "400px" }}>
        <BarChart barChartData={chartData} barChartOptions={chartOptions} />
      </VuiBox>
    );
  };

  return (
    <GlassCard>
      <VuiBox sx={{ height: "100%" }}>
        <ChartInfoTooltip
          title={`Top Mentioned Products - ${competitorName}`}
          tooltipText={"Shows a bar chart of the most frequently mentioned products within the selected timeframe, ranked by total mentions. How to use: Quickly identify which products are your competitors current priority. Use this to understand focus areas for competitors or assess your own products\' market presence."}
        >
          {renderContent()}
        </ChartInfoTooltip>
      </VuiBox>
    </GlassCard>
  );
}

export default TopMentionedProducts; 